import store from '../../store/configure-store';


/**
 * customizationParser
 * 
 * @param {string} login 
 * @returns 
 */
export const customizationParser = () => {
  const { login } = store.getState('login');
  const customization = login?.customization;

  if (!customization) return null;

  if (typeof customization === 'string') {
    try {
      return JSON.parse(customization);
    } catch (e) {
      console.error('COULD NOT parse config', e);
      return null;
    }
  }

  return customization;
};

export const getCurrencyNumberOfDigits = () => {
  const {login} = store.getState('login');
  
  return login?.CurrencyNumberOfDigits;
}
